import { local } from './local';
export const environment = {
  production: local.production,
  baseUrl: local.baseUrl,
  imageUrl:   local.imageUrl,
  recaptcha: local.recaptcha,
  clientKey: local.clientKey,
  apiLoginID: local.apiLoginID
};
